var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTabbarSwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.74 0.99H3.74001C2.22122 0.99 0.990005 2.22122 0.990005 3.74V12.54C0.990005 14.0588 2.22122 15.29 3.74001 15.29H14.74C16.2588 15.29 17.49 14.0588 17.49 12.54V3.74C17.49 2.22122 16.2588 0.99 14.74 0.99Z",
    stroke: "#6B6B6B",
    strokeWidth: 1.98,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49001 0.99V15.29",
    stroke: "#6B6B6B",
    strokeWidth: 1.98,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.76 6.27L10.78 8.14L12.76 10.01",
    stroke: "#6B6B6B",
    strokeWidth: 1.98,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabbarSwitch);
export default __webpack_public_path__ + "static/media/tabbar-switch.2ed75abdbb1c5f63076e7a1b5033ab9c.svg";
export { ForwardRef as ReactComponent };